const messages = {
  titleDesktop: 'Selecciona tu centro más cercano, para escanear tu sonrisa en 3D ',
  titleMobile: 'Selecciona tu centro más cercano ',
  welcome: '{Name}, la sonrisa de tus sueños esta cerca',
}

export default messages
